export default function GlowOrbs() {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
      <div
        className="orb-anim absolute -top-32 -left-32 w-[480px] h-[480px] rounded-full blur-[120px] opacity-40"
        style={{ background: "radial-gradient(circle, #1E3A8A 0%, transparent 60%)" }}
      />
      <div
        className="orb-anim-2 absolute top-40 right-[-120px] w-[520px] h-[520px] rounded-full blur-[140px] opacity-30"
        style={{ background: "radial-gradient(circle, #10B981 0%, transparent 60%)" }}
      />
    </div>
  );
}
